// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponMemberMemberNumberStatusMemberNumberStatusResponse {
    static getAttributeTypeMap() {
        return CouponMemberMemberNumberStatusMemberNumberStatusResponse.attributeTypeMap;
    }
}
CouponMemberMemberNumberStatusMemberNumberStatusResponse.discriminator = undefined;
CouponMemberMemberNumberStatusMemberNumberStatusResponse.additionalProperties = false;
CouponMemberMemberNumberStatusMemberNumberStatusResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtCardMemberNumberStatusResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=couponMemberMemberNumberStatusMemberNumberStatusResponse.js.map